import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

export const getdynamicFormReducerData = (state: RootState) => state.dynamicForm;

export const getSubmittedPageName = createSelector([getdynamicFormReducerData], (data) => data.submittedPageName);
